import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { signIn } from '../../services/api';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await signIn(email, password);
      login(data.token, { email });
      navigate('/');
    } catch (err) {
      setError(err.message || 'Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      {/* Left panel — azul marino */}
      <div style={styles.leftPanel}>
        <div style={styles.leftContent}>
          <div style={styles.logoCircle}>VS</div>
          <h1 style={styles.leftTitle}>VivaSmart</h1>
          <p style={styles.leftSub}>Sistema de Planeación Agrícola</p>
          <div style={styles.divider} />
          <p style={styles.leftDesc}>
            Gestiona cultivos, actividades y colaboradores de manera eficiente en todas tus unidades de negocio.
          </p>
        </div>
        <p style={styles.leftFooter}>
          © {new Date().getFullYear()} VivaSmart · Todos los derechos reservados
        </p>
      </div>

      {/* Right panel — blanco */}
      <div style={styles.rightPanel}>
        <div style={styles.formCard}>
          <h2 style={styles.formTitle}>Iniciar sesión</h2>
          <p style={styles.formSub}>Ingresa tus credenciales para continuar</p>

          {error && (
            <div className="alert alert-error" style={{ marginBottom: 18 }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Correo electrónico</label>
              <input
                type="email"
                className="input-field"
                placeholder="usuario@empresa.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label className="form-label">Contraseña</label>
              <input
                type="password"
                className="input-field"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg"
              disabled={loading}
              style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}
            >
              {loading ? (
                <>
                  <div className="spinner" style={{ width: 15, height: 15, borderWidth: 2 }} />
                  Verificando...
                </>
              ) : 'Ingresar al sistema'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
  },
  /* Left */
  leftPanel: {
    width: 360,
    flexShrink: 0,
    background: 'var(--sidebar-bg)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '48px 40px 32px',
  },
  leftContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  logoCircle: {
    width: 56, height: 56,
    background: '#fdd835',
    borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 20, fontWeight: 800, color: '#1a237e',
    marginBottom: 8,
  },
  leftTitle: {
    fontSize: 28,
    fontWeight: 700,
    color: '#fff',
    letterSpacing: '-0.02em',
    lineHeight: 1,
  },
  leftSub: {
    fontSize: 14,
    color: 'rgba(255,255,255,0.65)',
    fontWeight: 400,
    marginTop: -8,
  },
  divider: {
    width: 40,
    height: 3,
    background: '#fdd835',
    borderRadius: 2,
    margin: '8px 0',
  },
  leftDesc: {
    fontSize: 14,
    color: 'rgba(255,255,255,0.55)',
    lineHeight: 1.7,
    maxWidth: 260,
  },
  leftFooter: {
    fontSize: 11,
    color: 'rgba(255,255,255,0.3)',
  },
  /* Right */
  rightPanel: {
    flex: 1,
    background: '#f5f6fa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 32,
  },
  formCard: {
    background: '#fff',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-lg)',
    padding: '36px 40px',
    width: '100%',
    maxWidth: 400,
    boxShadow: 'var(--shadow-card)',
  },
  formTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: 'var(--text-primary)',
    marginBottom: 6,
  },
  formSub: {
    fontSize: 13,
    color: 'var(--text-secondary)',
    marginBottom: 24,
  },
};
